import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import BrandPositioning from "@/components/BrandPositioning";
import AudienceInsights from "@/components/AudienceInsights";
import ContentStrategy from "@/components/ContentStrategy";
import CaseStudies from "@/components/CaseStudies";
import CollabOptions from "@/components/CollabOptions";
import FinalCTA from "@/components/FinalCTA";
import { Toaster } from "@/components/ui/toaster";

const Home = () => {
  return (
    <div className="bg-[#0B0B0B]">
      <Header />
      <HeroSection />
      <BrandPositioning />
      <AudienceInsights />
      <ContentStrategy />
      <CaseStudies />
      <CollabOptions />
      <FinalCTA />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
